import { AddCartNonPricedProductFormValues } from "./types";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { schema } from "./constants";

export interface AddCartNonPricedProductFormProviderProps {
  children?: React.ReactNode;
  defaultFormValues?: Partial<AddCartNonPricedProductFormValues>;
}

export const AddCartNonPricedProductFormProvider = ({
  children,
  defaultFormValues,
}: AddCartNonPricedProductFormProviderProps) => {
  const methods = useForm<AddCartNonPricedProductFormValues>({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      ...defaultFormValues,
    },
    resolver: yupResolver(schema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
